import { ScaleElement } from '@scale/base-element';
import { Events } from '@scale/events';
import { morphSection } from '@scale/section-renderer';

class ScaleCartPage extends ScaleElement {
  static observeRefs = true;

  setup() {
    this.onDocument(Events.CART_UPDATED, (e) => this.#onCartUpdated(e));
  }

  updatedCallback() {
    this.invalidateRefs();
  }

  #onCartUpdated(event) {
    const sectionId = this.dataset.sectionId;
    const html = event.cart?.sections?.[sectionId];
    if (html) {
      morphSection(sectionId, html);
    }
  }
}

if (!customElements.get('scale-cart-page')) {
  customElements.define('scale-cart-page', ScaleCartPage);
}
